import { Injectable, TemplateRef } from '@angular/core';
import { ApiException } from '../models/models.swagger.generated';

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  public toasts: any[] = [];

  public show(header: string, textOrTpl: string | TemplateRef<any>, placeholder: string = '', options: any = {}) {
    this.toasts.push({ header, textOrTpl, placeholder, ...options });
  }

  public showSuccess(header: string, textOrTpl: string | TemplateRef<any>, placeholder: string = '') {
    this.show(header, textOrTpl, placeholder, { classname: 'e-toast-success text-light', delay: 10000, type: 'succcess' });
  }

  public showWarning(header: string, textOrTpl: string | TemplateRef<any>, placeholder: string = '') {
    this.show(header, textOrTpl, placeholder, { classname: 'e-toast-warning text-light', delay: 15000, type: 'warning' });
  }

  public showError(header: string, textOrTpl: string | TemplateRef<any>, placeholder: string = '', errorId?: number, errorDetail?: string) {
    this.show(header, textOrTpl, placeholder, { classname: 'e-toast-danger text-light', delay: 15000, type: 'error', errorId, errorDetail });
  }

  public showApiExeption(error: ApiException, title: string = 'i18n.errors.server-error.title', message: string = 'i18n.errors.server-error.message') {
    if(ApiException.isApiException(error)) {
      let detail;
      try{
        detail = JSON.parse(error.response).message;
      }catch(e){
        detail = error.response;
      }

      if(!detail){
        detail = error.response;
      }
      this.showError(title, message, null, null, detail);
    } else {
      this.showError(title, message);
    }
  }

  public remove(toast: any) {
    this.toasts = this.toasts.filter(t => t !== toast);
  }

  public doesErrorExistAlready(errorId: number) {
    if (!errorId) {
      return false;
    }
    return this.toasts.find(t => t.errorId === errorId) != null;
  }
}
